import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteDataService } from '../route-data.service';

@Component({
  selector: 'app-left-banner',
  templateUrl: './left-banner.component.html',
  imports: [CommonModule],
  standalone: true,
})
export class LeftBannerComponent {
  private routeDataService = inject(RouteDataService);
  public routeLayoutData = computed(()=> this.routeDataService.routeLayoutData())
}
